import type { LeaseStatus } from '@zg-rentals/ts-rental-manager-api-client';
import type { Lease, Property } from './index';
import type {
  APPLICANT_STATUSES,
  APPLICATION_RENTAL_PROTECTION_STATUSES,
  APPLICATION_STATUS_TYPES,
} from '../constants/stringConstants';

export type HTMLElementEvent<T extends HTMLElement> = Event & {
  currentTarget: T;
  target: T;
};

export type SwitchObject = {
  text: string;
  onClick: () => void;
  toggled: boolean;
  disabled?: boolean;
};

export type FaqSection = {
  label: string | React.ReactNode;
  description?: string | React.ReactNode;
};

export type RouterHistoryLocation = {
  hash: string;
  pathname: string;
  search: string;
};

export enum DocumentMode {
  FILL = 'FILL',
  EDIT = 'EDIT',
  EDIT_READ_ONLY = 'EDIT_READ_ONLY',
  READ = 'READ',
}

export type RouterHistory = {
  push: (path: string) => void;
  replace: (path: string) => void;
  location?: RouterHistoryLocation;
};

export enum DocumentBackend {
  dotloop = 'dotloop',
  selfUpload = 'self_upload',
  clauseManagement = 'clause_management',
}

export type LeaseActionProps = {
  history: RouterHistory;
  lease: Lease;
  property: Property;
  terminateActiveAction: () => void;
};

export type DocumentViewerMetadata = {
  signingStarted: boolean;
  signingComplete: boolean;
  saveLeaseEditorRequested: boolean;
};

export type Message = {
  label: string;
  title: string;
  message: string;
  note: string;
  type: string;
};

export enum TabIds {
  ONLINE_SIGNING = 'online signing',
  PRINT_TO_SIGN = 'print to sign',
  ELECTRONIC_SIGNING = 'electronic signing',
}

export type Application = {
  applicationId: string;
  applicants: Array<Applicant>;
  statusType: APPLICATION_STATUS_TYPES;
  rentalProtectionEligibility: APPLICATION_RENTAL_PROTECTION_STATUSES | null;
};

export type Applicant = {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  status?: APPLICANT_STATUSES;
  selected?: boolean;
};

export type LandlordProvidedDocument = {
  text: string;
  required?: boolean;
  included?: boolean;
};

export enum LeaseTypes {
  COSMOS = 'cosmos',
  SELF_UPLOAD = 'self_upload',
  SIGNED_SELF_UPLOAD = 'signed_self_upload',
  ZILLOW_WIZARD = 'zillow',
}

export type ZRMLeaseInfo = {
  lease_type_cd: LeaseTypes;
  lease_status_txt: LeaseStatus;
  lease_bundle_id: number;
};
